import { atom } from 'nanostores'
import type { ReminderDialogChoice } from '~/features/multi-page/lib/trial-reminder'

interface State {
  isOpen: boolean
  /** The formatted day the trial-end reminder will fire on. */
  reminderDate: string
}

const initialState: State = {
  isOpen: false,
  reminderDate: '',
}

export const $grantPermissionDialog = atom<State>(initialState)

let resolveChoice: ((choice: ReminderDialogChoice) => void) | null = null

export const grantPermissionDialog = {
  /**
   * Opens the reminder dialog and resolves with the user's choice: `confirm`
   * for "Remind Me", `dismiss` for "No Need" or any other close. Requesting
   * the notification permission is the trial reminder flow's job, not the
   * dialog's.
   */
  open: (reminderDate: string): Promise<ReminderDialogChoice> => {
    return new Promise((resolve) => {
      resolveChoice = resolve
      $grantPermissionDialog.set({ isOpen: true, reminderDate })
    })
  },

  onConfirm: () => {
    settle('confirm')
  },

  onDismiss: () => {
    settle('dismiss')
  },
}

function settle(choice: ReminderDialogChoice) {
  $grantPermissionDialog.set({
    ...$grantPermissionDialog.get(),
    isOpen: false,
  })
  resolveChoice?.(choice)
  resolveChoice = null
}
